import * as HeroStyles from '../dotdotdot/DotDotDotField.scss';
import * as React from 'react';
import { IconButton, ButtonType } from 'office-ui-fabric-react/lib/Button';
import { DeferredRender } from '../../../utilities/components/DeferredRender';

export interface IFollowedFieldProps {
  onClick: (evt: React.MouseEvent<HTMLButtonElement>) => void;
  isDisabled?: boolean;
  ariaLabel?: string;
  title?: string;
  hasFollowed?: boolean;
  pageLoadBarrier?: Promise<void>;
}

export const FollowedHeroField: React.StatelessComponent<IFollowedFieldProps> = (props: IFollowedFieldProps) => {
  let { onClick, isDisabled, ariaLabel, title, hasFollowed } = props;

  if (!isDisabled) {
    isDisabled = false;
  }

  const iconName = hasFollowed ? 'SingleBookmarkSolid' : 'SingleBookmark';

  return (
    <DeferredRender barrier={ props.pageLoadBarrier }>
      <IconButton
        className={ `${HeroStyles.heroButton} ${HeroStyles.followHeroButton}` }
        onClick={ onClick }
        buttonType={ ButtonType.hero }
        aria-label={ ariaLabel }
        data-automationid='FieldRender-Followed'
        iconProps={
          { iconName: iconName }
        }
        title={ title }
      />
    </DeferredRender>
  );
};
